import { ParsedUrlQuery } from 'querystring';

import { useCallback } from 'react';

import {
    BrandCmsRouteName,
    generateBrandUrl,
    generateRewritePath,
    generateFooterMobileApplicationUrl,
    generateMobileApplicationUrl,
    generateUrl,
    generateUrlMayNotExist,
    RouteName,
    RouteParams,
} from '../utilities/routing/routing';

import { MobileApplicationStore } from './useAppMobile';
import { useLocale } from './useLocale';

export function useUrlGenerator() {
    const { locale: currentLocale } = useLocale();

    return {
        generateUrl: useCallback(
            (routeName: RouteName, params?: RouteParams, locale = currentLocale) => {
                return generateUrl(routeName, locale, params, true);
            },
            [currentLocale],
        ),
        generatePath: useCallback(
            (routeName: RouteName, params?: RouteParams, locale = currentLocale) => {
                return generateUrl(routeName, locale, params, false);
            },
            [currentLocale],
        ),
        generateUrlMayNotExist: useCallback(
            (routeName: RouteName, params?: RouteParams, locale = currentLocale) => {
                return generateUrlMayNotExist(routeName, locale, params, true);
            },
            [currentLocale],
        ),
        generatePathMayNotExist: useCallback(
            (routeName: RouteName, params?: RouteParams, locale = currentLocale) => {
                return generateUrlMayNotExist(routeName, locale, params, false);
            },
            [currentLocale],
        ),
        generateBrandUrl: useCallback(
            (routeName: BrandCmsRouteName, locale = currentLocale) => {
                return generateBrandUrl(routeName, locale);
            },
            [currentLocale],
        ),
        generateFooterMobileApplicationUrl: useCallback((os: MobileApplicationStore) => {
            switch (os) {
                case 'apple':
                    return generateFooterMobileApplicationUrl('apple');
                case 'google':
                    return generateFooterMobileApplicationUrl('google');
            }
        }, []),
        generateMobileApplicationUrl: useCallback(
            (os: MobileApplicationStore) => {
                return generateMobileApplicationUrl(currentLocale, os);
            },
            [currentLocale],
        ),
        generateRewritePath: useCallback((routeName: RouteName, params?: ParsedUrlQuery) => {
            return generateRewritePath(routeName, params);
        }, []),
    };
}
